<template>
    <div>
        <b-modal title="Expansion Manager"
                 size="xl"
                 class="font-weight-bold h-75 m-auto"
                 centered
                 style="height: 500px;"
                 no-close-on-backdrop
                 v-model="expansionManagerDialogOpen"
                 @close="closeOrCancelButtonPressed"
                 @hidden="onDialogHidden">

            <b-row v-if="systemExpandables">
                <b-tabs class="w-75 pl-3" v-model="tabIndex">

                    <b-tab title="Your Expansions" class="pt-2" scrollable style="border-left: 1px solid #DEE2E6; border-right: 1px solid #DEE2E6; border-bottom: 1px solid #DEE2E6; ">
                        <b-container class="mt-1 mb-1" style="overflow-y: scroll; max-height: 400px;" id="myContainer" v-if="filteredExpansions.length">

                            <b-table id="expansionTable" ref="expansionTable"
                                     :items="filteredExpansions"
                                     :fields="visibleExpansionFields"
                                     :per-page="perPage"
                                     table-class="table-class"
                                     :current-page="currentPage"
                                     thead-class="hidden_header"
                                     small selectable
                                     class="smaller"
                                     select-mode="range"
                                     @row-selected="onRowSelected">

                                <!--@row-selected="onExpansionRowSelected"-->

                                <template v-slot:cell(short)="{ item }">
                                    {{ item.short }}
                                </template>
                                <template v-slot:cell(long)="{ item }">
                                    {{ item.long }}
                                    <b-icon icon="lock" v-if="containsSpaces(item.long) &&  item.locked" v-b-tooltip.hover title="Check if you want 'spaces' to be replaced by 'non-brekaing-spaces'"></b-icon>
                                    <b-badge v-if="justAddedUUID == item.uuid && currentShort == ''" pill style="background-color: yellow; color: #000;" class="pl-2 pr-2">just added</b-badge>
                                </template>

                                <template v-slot:cell(lastUsed)="{ item }">
                                    {{ formatDateTime(item.lastUsed, 'DD MMM YYYY') }}
                                </template>

                                <template v-slot:cell(actions)="{ item }" class="w-25">
                                    <b-button size="sm" block variant="outline-secondary" class="float-left w-50 p-0 m-0" title="Edit expansion" v-on:click="editExpansion(item.uuid)"><i class="fas fa-edit"></i></b-button>
                                    <b-button size="sm" block variant="outline-danger" class="float-right w-50 p-0 m-0" title="Delete expansion" v-on:click="deleteExpansion(item.uuid)"><i class="fas fa-times"></i></b-button>
                                </template>

                            </b-table>

                            <!--old version without table-->
                            <!--<b-row class="" v-for="(expansion,index) in filteredExpansions" :key="index" v-bind:class="{ 'custom-bg': index % 2 }">
                                <b-col cols="2">{{ expansion.short }}</b-col>
                                <b-col cols="6">
                                    {{ expansion.long }}
                                    <b-icon icon="lock" v-if="containsSpaces(expansion.long) &&  expansion.locked" v-b-tooltip.hover title="Check if you want 'spaces' to be replaced by 'non-brekaing-spaces'"></b-icon>
                                    <b-badge v-if="justAdded && index == 0 && currentShort == ''" pill style="background-color: yellow; color: #000;" class="p-2">just added</b-badge>
                                </b-col>
                                <b-col cols="2" class="text-right">{{ formatDateTime(expansion.lastUsed, 'DD MMM YYYY') }}</b-col>

                                <b-col cols="2" class="">
                                    <b-button size="sm" block variant="outline-secondary" class="float-left w-50 p-0 m-0" title="Edit expansion" v-on:click="editExpansion(expansion.uuid)"><i class="fas fa-edit"></i></b-button>
                                    <b-button size="sm" block variant="outline-danger" class="float-right w-50 p-0 m-0" title="Delete expansion" v-on:click="deleteExpansion(expansion.uuid)"><i class="fas fa-times"></i></b-button>
                                </b-col>
                            </b-row>-->

                        </b-container>
                        <div v-else class="small p-2">No expansions set up yet. <br />Use the 2 textboxes 'short' and 'long' at the bottom to start adding. <br />Use 'TAB' to add an expansion.</div>
                    </b-tab>

                    <b-tab title="Usage Stats & Clean up">
                        <b-container class="bv-example-row mt-3" style="overflow-y: scroll; max-height: 400px;">
                            <div v-if="notUsedExpansions.length">
                                <b-button size="sm" class="m-1 smaller p-0 pr-1 pl-1" :variant="expansion.preserve ? 'info' : 'outline-danger'"
                                          @click="preserveExpansion(expansion.uuid)"
                                          v-for="(expansion,index) in notUsedExpansions" :key="index">
                                    <strong>{{ expansion.short }}</strong><br />{{ expansion.long }}<br />{{ formatDateTime(expansion.lastUsed, 'DD MMM YYYY') }}
                                </b-button>
                            </div>

                            <div v-else>
                                No expansions match your selection
                            </div>
                        </b-container>
                    </b-tab>

                    <b-tab title="Import/Export Expansions" @activate-tab="numerOfImportedExpansions=0; numerOfSkippedExpansions=0;">
                        <b-container class="mt-3 w-100">

                            <div v-if="importedExpansionsSkipped.length == 0">
                                <h6>Import expansions from file</h6>
                                <p>You can upload and process your expansions csv file here. In order for the upload to work the file needs to adhere to the following format:</p>
                                <ul class="small">
                                    <li>yh, your Honour</li>
                                    <li>ABC, Australian Broadcasting Corporation</li>
                                    <li>tw, the witness</li>
                                    <li>..., ...</li>
                                </ul>
                                Expansions short need to be at least 2 characters long<br />
                                Leading and traling spaces will be trimmed
                            </div>
                            <div v-else>
                                <h6>{{ importedExpansionsSkipped.length }} expansions skipped during import</h6>
                                <b-container class="mt-1 mb-1 p-0" style="overflow-y: scroll; overflow-x: hidden; max-height: 400px; border: 1px solid #DEE2E6;" id="myContainer" v-if="filteredExpansions.length">
                                    <b-row class="" v-for="(skippedExpansion,skipIndex) in importedExpansionsSkipped" :key="skipIndex" v-bind:class="{ 'custom-bg': skipIndex % 2 }">
                                        <b-col cols="3">{{ skippedExpansion.short }}</b-col>
                                        <b-col cols="9">
                                            {{ skippedExpansion.long }}
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </div>

                            <b-form-file v-model="expansionsImportFile"
                                         id="expansion-upload"
                                         placeholder="Choose a file or drop it here..."
                                         class="mt-3 w-50"
                                         drop-placeholder="Drop file here..."
                                         @input="importExpansionsFile"
                                         size="sm"></b-form-file>
                        </b-container>
                    </b-tab>
                </b-tabs>

                <!--right hand side panel for tab 1 -->
                <div class="pl-2 pr-3 w-25" v-if="tabIndex===0">
                    <b-card title="" header-tag="header" footer-tag="footer" class="w-100">
                        <template #header>
                            <b-form-input placeholder="type to filter" v-model="expansionFilter" size="sm"></b-form-input>
                        </template>
                        <strong>Filtered:</strong>
                        <b-card-text class="small"> {{ filteredExpansions.length }} expansions</b-card-text>
                        <strong>Total:</strong>
                        <b-card-text class="small">{{ systemExpandables.length }} expansions</b-card-text>

                        <div class="mt-3">
                            <b-pagination v-model="currentPage"
                                          :total-rows="filteredExpansions.length"
                                          :per-page="perPage"
                                          size="sm"
                                          class="m-0 p-0"></b-pagination>

                            <b-card-text class="small">{{ Math.ceil(filteredExpansions.length/perPage) }} page(s) / {{ perPage }} items per page</b-card-text>

                        </div>
                        <template #footer v-if="systemExpandables.length">
                            <b-button @click="removeSelectedExpandables"
                                      size="sm" class="w-100 mb-2"
                                      variant="outline-danger"
                                      v-if="selectedExpansionRows.length > 0">Remove {{ selectedExpansionRows.length }} selected expansions</b-button>
                            <b-button @click="removeAllExpandables" size="sm" class="w-100" variant="outline-danger">Remove all expansions</b-button>
                        </template>

                    </b-card>
                </div>

                <div class="pl-2 pr-3 w-25" v-if="tabIndex===1">
                    <!--right hand side panel for tab 2 -->
                    <b-card header-tag="header" footer-tag="footer" class="w-100">
                        <b-card-text class="small">
                            <strong>Expansions use:</strong>
                        </b-card-text>
                        <b-form-group>
                            <b-form-radio v-model="notUsedFor" size="sm" name="notUsedFor" value="never used">Never used</b-form-radio>
                            <b-form-radio v-model="notUsedFor" size="sm" name="notUsedFor" value="12">> 12 months</b-form-radio>
                            <b-form-radio v-model="notUsedFor" size="sm" name="notUsedFor" value="6">> 6 months</b-form-radio>
                            <b-form-radio v-model="notUsedFor" size="sm" name="notUsedFor" value="3">> 3 months</b-form-radio>
                            <b-form-radio v-model="notUsedFor" size="sm" name="notUsedFor" value="2">> 2 months</b-form-radio>
                            <b-form-radio v-model="notUsedFor" size="sm" name="notUsedFor" value="1">> 1 month</b-form-radio>
                        </b-form-group>

                        <div class="mb-2">
                            <b-progress :value="notUsedExpansions.length" variant="warning" :max="systemExpandables.length" show-value></b-progress>
                        </div>
                        <div class="m-auto small">You did not use <strong>You have {{notUsedExpansions.length}} expansions</strong> that haven't been used in the last <strong>{{ notUsedFor }} months</strong>. These account for <strong>{{ Math.floor(notUsedExpansions.length / systemExpandables.length * 100,'') }}</strong>% of your total. You can either <strong>preserve them</strong> them or <strong>delete</strong> the rest.</div>

                        <b-button-group size="sm" class="mt-2 w-100">
                            <b-button variant="info"
                                      disabled>
                                Preserving {{ numberOfPreservedExpansions }} Expansions
                            </b-button>

                            <b-button variant="outline-danger"
                                      @click="invertExpansionSelection"
                                      v-b-tooltip.hover
                                      title="Invert preserved/deletable selections">
                                <i class="fas fa-retweet"></i>
                            </b-button>

                        </b-button-group>
                        <template #footer>
                            <b-button @click="removeExpandables" size="sm" class="w-100" variant="outline-danger">Remove {{ notUsedExpansions.length - numberOfPreservedExpansions }} Expansions</b-button>
                        </template>
                    </b-card>
                </div>

                <!-- tab 3 -->
                <div class="pl-2 pr-3 w-25" v-if="tabIndex===2">
                    <b-card header-tag="header" footer-tag="footer" class="w-100">
                        <template #header>
                            <strong>Import Results</strong>
                        </template>
                        <div>
                            Imported:
                            <b-progress :value="numerOfImportedExpansions" variant="success" :max="totalExpansionImportLines" show-value></b-progress>
                        </div>
                        <div class="mt-2">
                            Skipped <span v-if="numerOfSkippedExpansions > 0">[{{ numerOfSkippedExpansions }}]</span>:
                            <b-progress :value="numerOfSkippedExpansions" variant="danger" :max="totalExpansionImportLines" show-value></b-progress>
                        </div>
                        <template #footer>
                            <b-button @click="exportExpansions" size="sm" class="w-100" variant="outline-info">Export all expansions</b-button>
                        </template>
                    </b-card>
                </div>

            </b-row>

            <template #modal-footer>

                <b-row class="w-100">
                    <b-col cols="2">
                        <b-form-input id="abbreviationInput"
                                      ref="abbreviationInput"
                                      v-on:focus="setFocus('abbreviationInput')"
                                      v-on:blur="looseFocus('abbreviationInput')"
                                      @keydown.native="sanitizeExpansionShort"
                                      size="sm" v-model="currentTempShort" placeholder="short: min length 2" class="" v-if="tabIndex===0">
                        </b-form-input>
                    </b-col>
                    <b-col cols="9">
                        <b-form-input id="expansionInput"
                                      ref="expansionInput"
                                      v-on:focus="setFocus('expansionInput')"
                                      :disabled="currentTempShort.length<2"
                                      v-on:blur="looseFocus('expansionInput')"
                                      size="sm" v-model="currentTempLong" placeholder="long: min length 2" v-if="tabIndex===0">
                        </b-form-input>
                    </b-col>
                    <b-col cols="1">
                        <b-form-checkbox id="nonBreakingCheckbox"
                                         ref="nonBreakingCheckbox"
                                         v-on:focus="setFocus('nonBreakingCheckbox')"
                                         v-if="containsSpaces(currentTempLong)"
                                         v-model="currentTempLocked">
                            <b-icon icon="lock" v-if="containsSpaces(currentTempLong)" v-b-tooltip.hover title="Check if you want 'spaces' to be replaced by 'non-brekaing-spaces'"></b-icon>
                        </b-form-checkbox>

                        <!-- this is a fake UI element to have an anchor -->
                        <b-form-input id="fullStop" ref="fullStop" size="sm" v-on:focus="setFocus('fullStop')" style="width: 0px; height:0px; border: 1px solid #FFF;"></b-form-input>
                    </b-col>
                </b-row>
                <b-row class="w-100 border-top">
                    <b-col cols="12" class="float-right">
                        <b-button variant="success" size="sm" class="pl-2 pr-2 mt-2 float-right"
                                  @click="saveAndExitPressed"
                                  :disabled="currentTempLong.length > 0 || currentTempShort.length > 0">Save & exit</b-button>
                        <b-button size="sm" class="mr-2 pl-2 pr-2 float-right mt-2" @click="closeOrCancelButtonPressed">Cancel</b-button>
                    </b-col>
                </b-row>
            </template>

        </b-modal>

        <b-modal :title="(mode == 'quick-add-expansion') ? 'Add Expansion' : 'Edit Expansion'"
                 size="md"
                 class="font-weight-bold h-75 m-auto"
                 centered
                 no-close-on-backdrop
                 v-on:hide="onHideAddEdit"
                 v-model="showAddEditExpansionsModal">
            <div>
                <b-row class="mb-1">
                    <b-col cols="4">
                        <b-form-input size="sm" v-model="currentShort" placeholder="short" @keydown.native="sanitizeExpansionShort" autofocus></b-form-input>
                    </b-col>

                    <b-col cols="1">
                        <b-form-checkbox v-if="containsSpaces(currentLong)" v-model="currentLocked">
                            <b-icon icon="lock" v-b-tooltip.hover title="Check if you want 'spaces' to be replaced by 'non-brekaing-spaces'"></b-icon>
                        </b-form-checkbox>
                    </b-col>

                    <b-col cols="7" v-if="containsSpaces(currentLong)">
                        don't break expanded text
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col cols="12">
                        <b-form-textarea id="currentLong"
                                         v-model="currentLong"
                                         @keydown.native="supressEnterKey"
                                         placeholder="expanded text"
                                         rows="3"
                                         size="sm"
                                         max-rows="6">
                        </b-form-textarea>
                    </b-col>
                </b-row>
            </div>

            <template v-slot:modal-footer="{  }">
                <b-button size="sm" @click="onHideAddEdit">Cancel</b-button>
                <b-button size="sm" variant="success" :disabled="currentShort.length < 2 || currentLong.length < 2 || currentShort.indexOf(' ') >= 0"
                          @click="saveUpdateExpansion">Save/Update</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import UuidMixins from '../../mixins/UuidMixins';
    import DateTimeMixin from '../../mixins/DateTimeMixin';

    Vue.use(BootstrapVue);

    export default {
        name: 'TopscribeExpansionManager',
        mixins: [UuidMixins, DateTimeMixin],
        components: {
        },
        model: {
            event: 'change',
            prop: 'active',
        },
        props: {

            active: {
                type: Boolean,
                default: false
            },
            systemExpandablesIncoming: {
                type: Array,
                required: true
            },
            mode: {
                type: String,
                default: 'manage-expansions',
                validator: function (value) {
                    // The value must match one of these strings
                    return (['manage-expansions', 'quick-add-expansion'].indexOf(value) !== -1);
                }
            },
            showAddEditModal: {
                type: Boolean,
                default: false
            },
            highlightedLong: {
                type: String,
                default: ''
            }
        },

        data: function () {
            return {
                currentTempShort: '',
                currentTempLong: '',
                currentTempLocked: false,

                tabIndex: 0,
                totalExpansionImportLines: 0,
                numerOfImportedExpansions: 0,
                numerOfSkippedExpansions: 0,

                importMode: false,
                expansionsImportFile: null,
                importedExpansions: null,
                importedExpansionsSkipped: [],

                numberOfRandomExpansions: 100,
                numberOfPreservedExpansions: 0,

                expansionManagerDialogOpen: false,
                showAddEditExpansionsModal: false,

                systemExpandables: [],
                userExpandablesModifications: [],
                systemExpandablesBackUp: [],

                visibleExpansionFields: [

                    { key: 'short', label: 'short' },
                    { key: 'long', label: 'long', tdClass: 'format-long' },
                    { key: 'lastUsed', label: 'last used' },
                    { key: 'actions', label: '', tdClass: 'format-actions' }
                ],
                selectedExpansionRows: [],

                perPage: 50,
                currentPage: 1,

                expansionFilter: '',

                currentErrors: null,
                showErrors: false,

                currentUUID: null,
                currentShort: '',
                currentLong: '',
                currentLocked: false,
                currentModification: '',
                currentLastUsed: null,

                notUsedFor: 3, // nr of months
                justAddedUUID: null

            }
        },

        computed: {

            filteredExpansions: function () {

                var filteredExpansionList = [];

                //var start = Date.now();

                if (this.systemExpandables && this.systemExpandables.length) {
                    // to make sure that THIS referes to the component inside the forEachfilteredExpansions
                    var thisComponent = this;

                    this.systemExpandables.forEach(function (expansion) {

                        if (thisComponent.expansionFilter != '') {
                            if (expansion.short.toLowerCase().indexOf(thisComponent.expansionFilter.toLowerCase()) != -1 ||
                                expansion.long.toLowerCase().indexOf(thisComponent.expansionFilter.toLowerCase()) != -1) {
                                filteredExpansionList.push(expansion);
                            }
                        }
                        else filteredExpansionList = thisComponent.systemExpandables;
                    });
                }
                //var end = Date.now();
                //var duration = end - start;
                //console.log('Duration: ' + duration);

                return filteredExpansionList;
            },

            notUsedExpansions: function () {

                const cutoff = new Date();
                // Subtract the selected number of months (unless “never used”)
                if (this.notUsedFor !== 'never used') {
                    cutoff.setMonth(cutoff.getMonth() - Number(this.notUsedFor));
                }

                return (this.systemExpandables || []).filter(exp => {
                    // “Never used” case: include if no lastUsed or it’s literally 'never used'
                    if (this.notUsedFor === 'never used') {
                        return !exp.lastUsed || exp.lastUsed === 'never used';
                    }

                    // Otherwise, parse lastUsed and compare to cutoff
                    const lastDate = new Date(exp.lastUsed);
                    return lastDate < cutoff;
                });
            },
        },

        watch: {
            active: function () {

                if (this.active) {
                    this.systemExpandables = JSON.parse(JSON.stringify(this.systemExpandablesIncoming));
                    this.numerOfImportedExpansions = 0;
                    this.numerOfSkippedExpansions = 0;
                    this.currentShort = '';
                    this.currentLong = '';
                    this.currentLocked = false;

                    this.userExpandablesModifications = JSON.parse(localStorage.getItem('systemExpandablesModifications'));
                    // the above should at a minimu return [] ... which is set in mounted() of TopscribeEditor
                    if (this.userExpandablesModifications === null) this.userExpandablesModifications = [];

                    if (this.mode == 'manage-expansions') this.expansionManagerDialogOpen = true;
                    if (this.mode == 'quick-add-expansion') this.showAddEditExpansionsModal = true;
                } else {

                    this.expansionManagerDialogOpen = false;
                    this.showAddEditExpansionsModal = false;
                }
            },
            showAddEditModal: function () {
                if (this.showAddEditModal) {
                    this.onDialogShown();
                    /// this.addExpansionMode = true; old var
                    this.currentShort = '';
                    this.currentLong = '';
                    this.currentLocked = false;
                }
                this.showAddEditExpansionsModal = this.showAddEditModal;
            },
            highlightedLong: function () {
                this.currentLong = this.highlightedLong;
            }
        },

        methods: {

            exportExpansions: function () {
                const items = this.systemExpandables;
                const fields = ['short','long','locked'];

                if (!items.length || !fields.length) return;

                const rows = items.map(item =>
                    fields.map(field =>
                        `${String(item[field] ?? "").replace(/"/g, '""')}`
                    ).join(",")
                );

                const csvContent = [...rows].join("\n");

                const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
                const url = URL.createObjectURL(blob);

                const a = document.createElement("a");
                a.href = url;
                a.download = "expansion-export.csv";
                a.click();

                URL.revokeObjectURL(url);
            },

            onRowSelected(items) {
                this.selectedExpansionRows = items;
            },

            toggleSelection(item) {
                const exists = this.selectedExpansionRows.find(row => row.uuid === item.uuid);
                if (exists) {
                    this.selectedExpansionRows = this.selectedExpansionRows.filter(row => row.uuid !== item.uuid);
                } else {
                    this.selectedExpansionRows.push(item);
                }
            },

            supressEnterKey: function (event) {
                const keyCode = event.keyCode;
                // Enter Key
                if (keyCode == 13) event.preventDefault();
            },

            sanitizeExpansionShort: function (event) {
                const keyCode = event.keyCode;
                // (space)
                if (keyCode == 32) event.preventDefault();
            },

            importExpansionsFile: function () {

                if (this.expansionsImportFile) {
                    this.$bvModal.msgBoxConfirm([this.$createElement('div', { domProps: { innerHTML: 'Are you sure you want to import your expansions file ?' } })], {
                        title: 'Confirm Expansions Import',
                        size: 'md',
                        okVariant: 'danger',
                        okTitle: 'YES',
                        cancelTitle: 'NO',
                        centered: true
                    })
                        .then(value => {

                            if (value) {
                                this.importMode = true;
                                const reader = new FileReader();
                                reader.onload = (e) => {
                                    this.processExpansionsImport(e.target.result);
                                    this.importMode = false;
                                };
                                reader.readAsText(this.expansionsImportFile);
                            }
                        });
                } else {
                    this.$bvToast.toast('No file selected', {
                        title: 'Import',
                        variant: 'danger',
                        appendToast: true
                    });
                }
            },

            processExpansionsImport: function (expansionsUpload) {

                var lines = expansionsUpload.split(/[\r\n]+/g); // tolerate both Windows and Unix linebreaks
                this.totalExpansionImportLines = lines.length;
                this.importedExpansionsSkipped = [];

                this.importedExpansions = expansionsUpload;
                for (var i = 0; i < lines.length; i++) {
                    var expansionParts = lines[i].split(',');

                    this.currentShort = expansionParts[0].trim();
                    this.currentLong = expansionParts[1].trim();

                    // this block deals with MS Word export of a non breaking space
                    // the character is a non printable 'replacement-character'
                    // Note: it could also be, that another strange character coming from the
                    // word export is interpreted as 65533 in the resulting text file export
                    let char_65533 = String.fromCharCode(65533);
                    // right hand clause of the OR: checks if there is a 3rd col in the csv and if existing it's of string value 'true'
                    if (this.currentLong.indexOf(char_65533) > 0 || (expansionParts[2] && expansionParts[2].trim() == 'true')) {
                        this.currentLong = this.currentLong.replaceAll(char_65533, ' ');
                        this.currentLocked = true;
                    } else {
                        this.currentLocked = false;
                    }

                    if (this.currentShort.length < 2 || this.currentLong.length < 2) {
                        this.numerOfSkippedExpansions += 1
                        let skippedExpansion = { short: this.currentShort, long: this.currentLong };
                        this.importedExpansionsSkipped.push(skippedExpansion);
                    } else {
                        this.numerOfImportedExpansions += 1
                        this.saveUpdateExpansion();
                    }
                }
            },

            // delete single ... via red DEL cross in expansion list
            deleteExpansion: function (uuid) {

                var index = -1;
                var expansionToDelete = null;

                // 1) get the expansion we are dealing with ...
                index = this.systemExpandables.findIndex(element => element.uuid === uuid);
                expansionToDelete = this.systemExpandables[index];

                // remove from working copy for both cases
                this.systemExpandables.splice(index, 1);

                if (expansionToDelete.modification == 'added') {
                    index = this.userExpandablesModifications.findIndex(element => element.uuid === uuid);
                    this.userExpandablesModifications.splice(index, 1);
                } else {
                    expansionToDelete.modification = 'deleted';
                    this.userExpandablesModifications.push(expansionToDelete);
                }
                //this.$refs.expansionTable.refresh();
            },

            preserveExpansion: function (expansionUUID) {
                var position = this.systemExpandables.findIndex(element => element.uuid == expansionUUID);
                if (this.systemExpandables[position].preserve) this.numberOfPreservedExpansions--;
                else this.numberOfPreservedExpansions++;
                this.systemExpandables[position].preserve = !this.systemExpandables[position].preserve;
            },

            invertExpansionSelection: function () {

                this.notUsedExpansions.forEach(exp => {
                    exp.preserve = !exp.preserve;
                });

                this.numberOfPreservedExpansions = this.notUsedExpansions.filter(exp => exp.preserve).length;
            },

            // removing bulk from usages stats screen
            removeExpandables() {
                const countToDelete = this.notUsedExpansions.length - this.numberOfPreservedExpansions;
                const countToPreserve = this.numberOfPreservedExpansions;

                this.$bvModal.msgBoxConfirm(
                    `Are you sure you want to delete ${countToDelete} expansions? These expansions were not used for ${this.notUsedFor} months.`,
                    {
                        title: 'Please Confirm',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'YES',
                        cancelTitle: 'NO',
                        footerClass: 'p-2',
                        hideHeaderClose: true,
                        centered: true,
                    }
                ).then(confirmed => {
                    if (!confirmed) return;

                    let deleted = 0;

                    this.notUsedExpansions.forEach(expansion => {
                        if (expansion.preserve) return;

                        const index = this.systemExpandables.findIndex(e => e.uuid === expansion.uuid);
                        if (index === -1) return;

                        const [removedExpansion] = this.systemExpandables.splice(index, 1);
                        deleted++;

                        if (removedExpansion.modification === 'added') {
                            const modIndex = this.userExpandablesModifications.findIndex(e => e.uuid === removedExpansion.uuid);
                            if (modIndex !== -1) {
                                this.userExpandablesModifications.splice(modIndex, 1);
                            }
                        } else {
                            removedExpansion.modification = 'deleted';
                            this.userExpandablesModifications.push(removedExpansion);
                        }
                    });

                    if (deleted > 0) {
                        this.$bvToast.toast(`${deleted} expansion${deleted === 1 ? '' : 's'} deleted.`, {
                            title: 'Deleted',
                            variant: 'danger',
                            solid: true,
                            toaster: 'b-toaster-top-center',
                            autoHideDelay: 3000,
                        });
                    }

                    if (countToPreserve > 0) {
                        this.$bvToast.toast(`${countToPreserve} expansion${countToPreserve === 1 ? '' : 's'} preserved.`, {
                            title: 'Preserved',
                            variant: 'info',
                            solid: true,
                            toaster: 'b-toaster-top-center',
                            autoHideDelay: 3000,
                        });
                    }
                });
            },

            removeSelectedExpandables: function () {

                this.$bvModal.msgBoxConfirm('Are you sure you want to delete' + this.selectedExpansionRows.length + '  expansions? ', {
                    title: 'Please Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
                    .then(value => {

                        if (value) {
                            for (var i = 0; i < this.selectedExpansionRows.length; i++) {
                                // using single deleteExpansion method to remove selected rows from expansion table
                                this.deleteExpansion(this.selectedExpansionRows[i].uuid);
                            }
                            this.selectedExpansionRows = [];

                            this.$bvToast.toast(this.selectedExpansionRows + ' expansions deleted', {
                                title: 'Expansion Deletion',
                                variant: 'success',
                                appendToast: true
                            });
                        }
                    })
            },

            removeAllExpandables: function () {

                this.$bvModal.msgBoxConfirm('Are you sure you want to delete your expansions? ' + this.systemExpandables.length + ' expansions found.', {
                    title: 'Please Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
                    .then(value => {

                        if (value) {
                            var thisComponent = this;
                            this.systemExpandables.forEach(function (expansion) {

                                expansion.modification = 'deleted';
                                thisComponent.userExpandablesModifications.push(expansion);

                            });
                            this.systemExpandables = [];
                        }
                    })
            },

            handleEnterKey: function (e) {
                if (this.isEventTargetWithinElement(e.event, this.$refs.inputFields)) {
                    this.addToList();
                }
            },
            onDialogShown: function () {
                // create a full back up of the incoming expansions array property
                // in case of CANCEL we will us this to reset the state
                this.systemExpandables = JSON.parse(JSON.stringify(this.systemExpandablesIncoming));
                this.numerOfImportedExpansions = 0;
                this.numerOfSkippedExpansions = 0;
                this.currentShort = '';
                this.currentLong = '';
            },

            closeOrCancelButtonPressed: function () {

                this.userExpandablesModifications = [];
                this.systemExpandablesBackUp = [];
                this.$emit('change', false);
            },

            onDialogHidden: function () {
                this.$emit('change', false);
                this.expansionFilter = '';
                this.justAddedUUID = null;
                this.importedExpansionsSkipped = [];
            },

            containsSpaces: function (longExpansion) {
                return longExpansion.indexOf(' ') >= 0;
            },

            looseFocus: function (inputElement) {

                var element = document.getElementById(inputElement);
                element.style.backgroundColor = 'white';

                // those 2 ifs deal with the min length check of 2 for both fields.
                if (inputElement == 'abbreviationInput' && this.currentTempShort.length < 2) {
                    this.$refs['abbreviationInput'].focus();
                }
                if (inputElement == 'expansionInput' && this.currentTempLong.length < 2) {
                    this.$refs['expansionInput'].focus();
                }

                // this handles the case of TAB pressed after entering a long desc without spaces
                if (inputElement == 'expansionInput' && !this.containsSpaces(element.value) && this.currentTempShort.length >= 2 && this.currentTempLong.length >= 2) {
                    this.currentShort = this.currentTempShort;
                    this.currentLong = this.currentTempLong;
                    this.currentLocked = this.currentTempLocked;
                    this.saveUpdateExpansion();
                    this.$refs['abbreviationInput'].focus();
                }
            },

            setFocus: function (inputElement) {

                // Either we are at the end ...
                if (inputElement == 'fullStop') {
                    if (this.currentTempShort.length >= 2 && this.currentTempLong.length >= 2) {
                        this.currentShort = this.currentTempShort;
                        this.currentLong = this.currentTempLong;
                        this.currentLocked = this.currentTempLocked;

                        this.saveUpdateExpansion();
                    }
                    this.$refs['abbreviationInput'].focus();
                }
                // ... or highlight the next field
                else {
                    var element = document.getElementById(inputElement);
                    element.style.backgroundColor = 'yellow';
                }
            },

            // this is called from the expansion list via the icon - opens the small Edit dialog
            // it populates the modal and the 3 inputs
            editExpansion: function (uuid) {

                this.showAddEditExpansionsModal = true;
                var index = this.systemExpandables.findIndex(element => element.uuid == uuid);

                // prefill the input elements
                if (index >= 0) {
                    this.currentUUID = this.systemExpandables[index].uuid;
                    this.currentShort = this.systemExpandables[index].short;
                    this.currentLong = this.systemExpandables[index].long;
                    this.currentModification = this.systemExpandables[index].modification;
                    this.currentLocked = (this.systemExpandables[index].locked) ? true : false;
                }
            },

            randomDate: function (start, end) {
                return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
            },

            async saveUpdateExpansion() {

                // sanitze this.currentLong for all sorts of line breaks which might be copied into the LONG text area:
                // this.currentLong is used 2x in this method
                this.currentLong = this.currentLong.replace(/(\r\n|\r|\n)/g, ' ');
                this.justAddedUUID = null;

                if (this.currentUUID == null || this.currentUUID == '') { // ADD CASE - can only come from modal or fast lane

                    // here we know: we come via quick add modal or fast lane
                    // We know we have to add a new expansion, hence the object
                    var obj = {
                        "uuid": this.newUuid(),
                        "short": this.currentShort.toLowerCase(),
                        "long": this.currentLong,
                        "locked": (this.currentLocked) ? true : false,
                        lastUsed: null, // this.randomDate(new Date(2024, 0, 1), new Date())
                        modification: 'added'
                    };

                    // store the UUID in order to display the yellow 'just added' badge
                    this.justAddedUUID = obj.uuid;

                    // but we also have to check if the short EXISTs already !
                    var existingShortPosition = this.systemExpandables.findIndex(element => element.short === this.currentShort.toLowerCase());

                    if (existingShortPosition >= 0) {

                        var existingExpansionObj = this.systemExpandables[existingShortPosition];
                        // default overwride mode ... user has the option of setting to false with below dialog
                        var overwriteExistingExpansion = true;

                        if (!this.importMode) {
                            // get the user to confirm if they want to OVERWRITE or abandon
                            // when in import mode this dialog is never shown
                            overwriteExistingExpansion = await this.$bvModal.msgBoxConfirm('Expansion [' + existingExpansionObj.short + '] already exists! Do you want to replace the expanded text from [' + existingExpansionObj.long + '] to [' + obj.long + ']', {
                                title: 'Please Confirm',
                                size: 'sm',
                                buttonSize: 'sm',
                                okVariant: 'danger',
                                okTitle: 'YES',
                                cancelTitle: 'NO',
                                footerClass: 'p-2',
                                centered: true,
                                hideHeaderClose: true,
                            });
                        }

                        if (overwriteExistingExpansion) {
                            // when in import mode we overwrite existing expansions by default ... therefor decrease the numerOfImportedExpansions
                            if (this.importMode) this.numerOfImportedExpansions += -1;
                            // Basically the overwriting is a 2 step process at the server: delete the old expansion, add the new one
                            // 1) flag the existing expansion as modification: deleted
                            existingExpansionObj.modification = 'deleted';
                            this.userExpandablesModifications.push(existingExpansionObj);
                            this.systemExpandables.splice(existingShortPosition, 1);
                            // 2) add the new expansion
                            this.systemExpandables.unshift(obj);
                            this.userExpandablesModifications.push(obj);

                            if (this.mode == 'quick-add-expansion') {
                                this.saveAndExitPressed();
                            }
                            this.clearExpansionVariables();
                        }

                    } else {
                        // NO ... does not exist ... put new expansion in both arrays
                        this.systemExpandables.unshift(obj);
                        this.userExpandablesModifications.push(obj);
                        if (this.mode == 'quick-add-expansion') {
                            this.saveAndExitPressed();
                        }
                        this.clearExpansionVariables();
                    }

                } else { // EDIT case
                    // here we know we come from the little modal: EDIT CASE ONLY
                    // fixing up the working arayy so we have the local changes available to update list in front of us
                    // the the UIID which should exist ...
                    var position = this.systemExpandables.findIndex(element => element.uuid == this.currentUUID);

                    var myElement = {};
                    myElement.uuid = this.currentUUID;
                    myElement.short = this.currentShort.toLowerCase();
                    myElement.long = this.currentLong;
                    myElement.locked = this.currentLocked;
                    myElement.lastUsed = null;
                    myElement.modification = 'modified';

                    this.systemExpandables[position] = myElement;
                    this.userExpandablesModifications.push(myElement);
                    this.clearExpansionVariables();
                }
                this.$refs.expansionTable.refresh();
            },

            clearExpansionVariables: function () {

                this.currentUUID = null;
                this.currentShort = '';
                this.currentLong = '';
                this.currentLocked = null;
                this.currentTempShort = ''; // those 3 are the v-model
                this.currentTempLong = ''; // of the fast lane
                this.currentTempLocked = null; //
                this.currentModification = '';
                this.showAddEditExpansionsModal = false;
            },

            saveAndExitPressed: function () {

                // we push changes from local var into local storage
                localStorage.setItem('systemExpandablesModifications', JSON.stringify(this.userExpandablesModifications));
                // ... and then indicate that we want to SAVE changes to DB (save calls loadExpansions() when done)
                this.userExpandablesModifications = [];
                this.systemExpandablesBackUp = [];
                this.$emit('saveExpansionModificationsToDB');
                this.expansionManagerDialogOpen = false;
                this.showAddEditExpansionsModal = false;
                this.$emit('change', false);
            },

            onHideAddEdit: function () {
                this.clearExpansionVariables();
                if (this.mode == 'quick-add-expansion') this.$emit('change', false);
            },

        }, // methods

        mounted: function () {

        }
    }
</script>

<style>
    .hidden_header {
        display: none;
    }

    .table-sm th, .table-sm td {
        padding: 0.1rem !important;
        font-size: 0.9rem;
    }

    .format-actions {
        width: 15%;
    }

    .format-long {
        max-width: 50% !important;
    }

    .custom-bg {
        background-color: #eee;
    }

    b-table-row-selected {
        background-color: red;
    }

</style>
